// extracted by mini-css-extract-plugin
export default {"InterviewQuestionnaireSidebar":"styles_InterviewQuestionnaireSidebar__YDAp2"};